import { ImgProps } from "assets/images/types";

export default function ImgTodasAsFloresFooter1(props: ImgProps) {
	const { height = 276, width = 398 } = props;
	return (
		<img
			src="/assets/images/cases/todas-as-flores/todas-as-flores-footer-1.webp"
			alt="Humberto Carrão e Sophie Charlotte experimentando fragrância da Natura de Todas as Flores"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
